import { observer } from "mobx-react-lite";
import { useComplianceAnalysisBypassPopupStore } from "./ComplianceAnalysisBypassPopupStore";
import { FormControlLabel, FlexColumn, Switch, Text, TextField } from "designSystem/index";
import React from "react";
import styles from "./ComplianceAnalysisBypassPopupContent.module.css";

export const ComplianceAnalysisBypassPopupContent = observer(() => {
	const store = useComplianceAnalysisBypassPopupStore();
	const { bypassToggle, bypassReason, setBypassToggle, setBypassReason } = store;
	
	return (
		<FlexColumn
			gap={6}
			px={7}
			py={5}
		>	
			<FlexColumn
				alignItems="flex-start"
				gap={3}
			>
				<FormControlLabel
					className={styles.textLabel}
					control={(
						<Switch
							checked={bypassToggle} 
							onChange={setBypassToggle}
						/>
					)}
					labelPlacement="start"
					res="ComplianceAnalysisBypassToggle"
				/>
				<Text
					lineHeight={14}
					res="ComplianceAnalysisBypassPopupDescription" 
					size={12}
				/>
			</FlexColumn>
			<FormControlLabel 
				className={styles.textFieldLabel}
				control={(								
					<TextField
						disabled={!bypassToggle}
						fullWidth
						onChange={setBypassReason}
						value={bypassReason}
					/>
				)}
				fullWidth
				labelPlacement="start"
				required
				res="ComplianceAnalysisBypassTextfield"
				standalone
			/>
		</FlexColumn>
	);
});

export default ComplianceAnalysisBypassPopupContent; 